<template>
  <div id="app">
    <UWHeader></UWHeader>
    <div id="navigation">
			<div class="float-right" v-if="$route.path != '/'">
				<router-link class="btn btn-primary btn-skew float-right" to="/">⬅ Back</router-link>
			</div>
		</div>
		<div id="main">
			<router-view :api_root="api_root" />
		</div>
  </div>
</template>

<script>
// import socketCluster from 'socketcluster-client';
import { EventBus } from './event-bus.js';
import settings from './settings.prod.json';
// import settings from './settings.local.json';
// import bootstrap from 'bootstrap'

import UWHeader from './components/UWHeader';
// import "bootstrap/dist/css/bootstrap.min.css";

export default {
	name: 'App',
	components: {
		'UWHeader': UWHeader
	},
	data () {
		return {
			// socket: null,
			api_root: null,
			timeout: null
		}
	},
	created: function () {
		this.api_root = settings.api_url;
	},
	mounted: function () {
		let self = this;
		// var options = {
		// 	hostname: 'localhost',
		// 	port: 9991
		// };
		// var options = {
		// 	hostname: "enroll31.s.uw.edu",
		// 	path: "/socketcluster",
		// 	secure: true,
		// 	port: 443
		// };
		
		// Initiate the connection to the server
		// self.socket = socketCluster.create(options);

		// self.socket.on('connect', function () {
		// 	console.log('CONNECTED');
		// });

		// Listen to an event called 'rand' from the server
		// self.socket.on('random', function (num) {
		// 	let numl = num.toSource();
		// 	console.log('RANDOM: ' + numl);
		// });

		// Listen to an event called 'rand' from the server
		// self.socket.on('registration', function (num) {
		// 	let numl = num.toSource();
		// 	console.log('registration: ' + numl);
		// });

		/** data = {name = '', payload = {}} */
		// EventBus.$on('publish', function (data) {
			// let payload = null;
			// payload = JSON.stringify(data.payload);


			//DEBUG
			// console.log('on publish', data.name, JSON.stringify(data.payload));
			// if (!data.hasOwnProperty('name') || !data.hasOwnProperty('payload')) {
			// 	alert('malformed publish data');
			// }
			// self.socket.emit(data.name, JSON.stringify(data.payload));
		// });

		// self.socket.on('register', function () {
		// 	console.log('got register event');
		// });

		// var regChannel = self.socket.subscribe('register');
		// regChannel.watch(function (num) {
		// 	console.log('Register:', num);
		// });

		// window.onload = self.resetTimer();
		// document.onclick = self.resetTimer(); 

	// 	var inactivityTime = function () {
    // var time;
    // window.onload = resetTimer;
    // // DOM Events
    // document.onmousemove = resetTimer;
    // document.onkeydown = resetTimer;

    // function logout() {
    //     alert("You are now logged out.")
    //     //location.href = 'logout.html'
    // }

    
// };

		EventBus.$on('fetchError', function (data) { 
			console.log(data);

		});
		EventBus.$on('resetTimer', function () { 
			self.resetTimer();
		});
	},
	methods: {
		resetTimer: function () {
			let self = this;
			clearTimeout(self.timeout);
			// console.log('setTimeout', Date.now());
			self.timeout = setTimeout(function () {
				// console.log('setting timeout for ');
				console.log('Timing out', Date.now());
				self.$router.push('/')
			}, 60000) // 60 second timeout
		}
	}
}
</script>

<style>

html, body {
	font-size:17px;
}

/* @font-face {
    font-family: "Uni Sans Book";
    src: url('https://dev1.eis.washington.edu/em_kiosk/assets/fonts/UniSansBook.otf');
    font-weight:400;
}

@font-face {
    font-family: "Encode Sans Compressed";
    src: url('https://dev1.eis.washington.edu/em_kiosk/assets/fonts/UniSansBook.otf');
    font-weight:400;
} */

#main .container { background-color: #fff; padding-top: 1rem; position: absolute; margin-left: 3%; margin-right: 3%; z-index: 1; }

.title-prompt {
	font-family: "Encode Sans Compressed", "Uni Sans Book", "Open Sans", sans-serif;
	font-weight:300;
}

#app .btn {
	border-radius:0;
}

#app .btn-primary {
	background-color:#4b2e83;
	border-color:#4b2e83;
}

#app .closed-container {
	/* background-color: #3d465e; 
	border: solid 3px #3d465e;*/
	/* color: #ffffff; */
	z-index: 0;
}

#app .closed-container .btn-primary {
	background-color:#c2c8d7;
	border-color:#3d465e;
}


#app {
	font-family: 'Open Sans', Helvetica, Arial, sans-serif;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	text-align: center;
	color: #2c3e50;
	/* margin-top: 60px; */
	font-size:16px;
}

#navigation {
	position:fixed;
	width:100%;
	top:55px;
}


.btn-skew {
	position:relative;
}

.btn-skew::before {
    content: "";
    position: absolute;
    z-index: -1;
    top: -1px;
    -webkit-transform: skew(-20deg);
    -moz-transform: skew(20deg);
    -ms-transform: skew(-20deg);
    -o-transform: skew(-20deg);
    transform: skew(20deg);
    background-color: inherit;
    background: -webkit-linear-gradient(right, #4b2e83, #4b2e83 20px, white 21px, white 25px, rgba(255, 255, 255, 0));
    background: -o-linear-gradient(right, #4b2e83, #4b2e83 20px, white 21px, white 25px, rgba(255, 255, 255, 0));
    background: -moz-linear-gradient(right, #4b2e83, #4b2e83 20px, white 21px, white 25px, rgba(255, 255, 255, 0));
    background: linear-gradient(right, #4b2e83, #4b2e83 20px, white 21px, white 25px, rgba(255, 255, 255, 0));
    height: 40px;
    width: 20px;
	left: -10px;
	display: block;
}

.help-text {
	color:#777;
}

.queue-link {
	margin-bottom:1rem;
	white-space:normal;
	/* line-height:2rem; */
	min-height:5rem;
	border-width:0;
	display: flex;
	justify-content: center;
	align-items: center;
}

</style>
